import React, { useState, useEffect } from 'react';
import { Booking } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { object, string, number, boolean } from 'yup';
import { BookingController } from '../../controllers';
import { bookingStore, userStore } from '../../stores';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';
import { EditBooking } from '../../pages/Booking';

const EditBookingContainer = ({
	closeModal,
	validationSchema,
	editLink,
	setShowSurvey,
	cancelEdit,
	selectedLink,
	setEditLink,
	setViewBookings,
	setViewLinks,
	setCreateLinks,
}) => {
	const [loading, setLoading] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(
		constant.FEEDBACK.BOOKINGEDIT
	);

	const goToViewLinks = () => {
		setViewLinks(true);
		setViewBookings(false);
		setCreateLinks(false);
		setEditLink(false);
	};

	const id = selectedLink._id;

	const onSubmit = async values => {
		setLoading(true);
		let payload = {};
		payload = {
			...values,
		};

		delete payload.previewAmount;
		delete payload.previewFirstName;
		delete payload.previewLastName;
		delete payload.previewEmail;
		delete payload.previewMobile;
		delete payload.previewQuantity;

		if (payload.amount === '') {
			delete payload.amount;
		}

		if (payload.minDeposit === '') {
			delete payload.minDeposit;
		}

		if (editLink) {
			delete payload.amount;
			delete payload.currencyCode;

			const { status, errorMessage } = await BookingController.editBookingLink(
				id,
				payload
			);

			if (status === constant.Success) {
				MimaToastUtil.success({
					message: constant.Success,
				});
				setLoading(false);
				goToViewLinks();
				if (needFeedback._id) {
					setShowSurvey(true);
					userStore.setReviewId(needFeedback._id);
				}
				return;
			} else {
				setLoading(false);
				MimaToastUtil.error({ message: errorMessage });
			}
		}
	};

	return (
		<EditBooking
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			editLink={editLink}
			cancelEdit={cancelEdit}
			closeModal={closeModal}
			needFeedback={needFeedback}
			selectedLink={selectedLink}
			loading={loading}
		/>
	);
};

export default EditBookingContainer;
